import { TestIframe } from '../TestIframe/TestIframe';
import { useQueryClient } from '@tanstack/react-query';
import { useGetLearningHubTestContent } from 'queryHooks/learningHub';
import { useEffect } from 'react';

type ChapterTestProps = {
  chapterTestId: string;
  moduleId: string;
  isCompleted: boolean;
};

export const ChapterTest = ({ chapterTestId, moduleId, isCompleted }: ChapterTestProps) => {
  const queryClient = useQueryClient();
  const testContent = useGetLearningHubTestContent(chapterTestId);

  useEffect(
    () => () => {
      if (!isCompleted) {
        queryClient.invalidateQueries({ queryKey: ['moduleContents', moduleId] });
      }
    },
    []
  );

  return !testContent.isPending ? (
    <TestIframe area9LaunchUrl={testContent.data.launchUrl} lessonParams={testContent.data.parameters} />
  ) : (
    <></>
  );
};
